import { EventEmitter } from 'eventemitter3'
import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

@Mixin
export class WithConfirmModal extends Vue {
  private innerIsConfirming: boolean = false
  private readonly innerConfirmEventEmitter = new EventEmitter()

  get isConfirming(): boolean {
    return this.innerIsConfirming
  }

  confirm(): Promise<boolean> {
    this.innerIsConfirming = true

    return new Promise((resolve) => {
      this.innerConfirmEventEmitter.once('selected', (res: boolean) => {
        resolve(res)

        this.innerIsConfirming = false
      })
    })
  }

  onConfirmModalOk() {
    this.innerConfirmEventEmitter.emit('selected', true)
  }
  onConfirmModalCancel() {
    this.innerConfirmEventEmitter.emit('selected', false)
  }
}
